// extracted by mini-css-extract-plugin
export var card = "page-card-module--card--f1cef";
export var cardImg = "page-card-module--cardImg--3ef41";